import React from 'react';
import { SvgIcon, type SvgIconProps } from '@mui/material';
import { motion, useReducedMotion } from 'framer-motion';
import { RENDER_EVERY_FRAME, SPRING } from '../motion/motionTokens';

type Props = SvgIconProps & { checked?: boolean; checkColor?: string };

export default function RememberMeCheckboxIcon({ checked = false, checkColor = '#FFFFFF', ...props }: Props) {
  const reduced = useReducedMotion();
  return <SvgIcon {...props} viewBox="0 0 24 24" data-testid="remember-me-icon">
    <rect x={4} y={4} width={16} height={16} rx={1}
      fill={checked ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth={2} />
    <motion.path {...RENDER_EVERY_FRAME} d="M7 12.4 L10.3 15.6 L17.2 8.6"
      fill="none" stroke={checkColor} strokeWidth={2.3} strokeLinecap="round" strokeLinejoin="round"
      initial={false} animate={{ pathLength: checked ? 1 : 0 }} opacity={checked ? 1 : 0}
      transition={reduced ? { duration: 0 } : SPRING.snap} />
  </SvgIcon>;
}
